import React from 'react';
import { AboutBadge } from '../AboutBadge';
import functionalListPoint from './functional-list-point.png';

export function SectionFunctional() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mx-2 sm:mx-4">
      <section className="w-full bg-white p-4 sm:p-8 md:p-[55px_50px] lg:p-[55px_100px] rounded-3xl sm:rounded-[48px] m-auto relative z-[1]">
        <AboutBadge text="Функционал" />
        <h4 className="font-bold text-xl sm:text-2xl md:text-[32px] leading-tight sm:leading-[58px] my-3 sm:my-4">
          Найти
        </h4>
        <ul className="list-none m-0 p-0">
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${functionalListPoint})` }}
            />
            Субподрядные организаций для выполнения строительно-монтажных работ
          </li>
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start mt-2 sm:mt-[10px]">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${functionalListPoint})` }}
            />
            Строительно-монтажные объемы работ
          </li>
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start mt-2 sm:mt-[10px]">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${functionalListPoint})` }}
            />
            Строительные компании
          </li>
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start mt-2 sm:mt-[10px]">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${functionalListPoint})` }}
            />
            Производителей строительных материалов
          </li>
        </ul>
      </section>
      <section className="w-full bg-white p-4 sm:p-8 md:p-[55px_50px] lg:p-[55px_100px] rounded-3xl sm:rounded-[48px] m-auto relative z-[1]">
        <AboutBadge text="Функционал" />
        <h4 className="font-bold text-xl sm:text-2xl md:text-[32px] leading-tight sm:leading-[58px] my-3 sm:my-4">
          Объявить
        </h4>
        <ul className="list-none m-0 p-0">
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${functionalListPoint})` }}
            />
            Потребность в аренде или покупке специализированной техники
          </li>
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start mt-2 sm:mt-[10px]">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${functionalListPoint})` }}
            />
            Аутсорсинговые кадры из сферы строительной индустрии
          </li>
          <li className="flex text-black/65 text-sm sm:text-base leading-relaxed sm:leading-[36px] items-start mt-2 sm:mt-[10px]">
            <div
              className="inline-flex w-6 h-6 sm:w-8 sm:h-8 mt-[2px] mr-3 sm:mr-4 bg-center bg-cover shrink-0"
              style={{ backgroundImage: `url(${functionalListPoint})` }}
            />
            Продажу или закупку строительных материалов для текущих проектов
          </li>
        </ul>
      </section>
    </div>
  );
}
